<template>
<div class="content2">
  <div>
  </div>

  <div class="table-wrap">
    <el-table
      v-loading="loading"
      v-if="pageData" :data="pageData.list"
      border
      style="width: 100%" height="70vh">
      <el-table-column
        align="center"
        prop="project_name"
        label="项目名称"
        width="200" fixed>
      </el-table-column>
      <el-table-column
        align="center"
        prop="year_month"
        label="调整月份"
        width="200" fixed>
      </el-table-column>
      <el-table-column
        label="户数" align="center">
        <el-table-column
          prop="original_plan_count"
          label="本月计划" align="center">
        </el-table-column>
        <el-table-column
          prop="adjust_count"
          label="计划调整" align="center">
        </el-table-column>
        <el-table-column
          prop="current_plan_count"
          label="实际计划" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="金额" align="center">
        <el-table-column
          prop="original_plan_amount"
          label="本月计划" align="center">
        </el-table-column>
        <el-table-column
          prop="adjust_amount"
          label="计划调整" align="center">
        </el-table-column>
        <el-table-column
          prop="current_plan_amount"
          label="实际计划" align="center">
        </el-table-column>
      </el-table-column>

    </el-table>
  </div>
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                   :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                   @current-change="pageChange"></el-pagination>
  </div>
</div>
</template>

<script>
import ButlerHttp from "./common/ButlerHttp";

export default {
  name: "ExpeditingFeesPlanContenziosoAjustShow",
  data(){
    return{
      batch_number:"",
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
    }
  },
  mounted() {
    const that=this;
    that.batch_number=that.$route.query.batch_number
    setTimeout(function () {
      that.pageChange(1);
    },500);
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      ButlerHttp.get("/ProjectCollectionProceedingPlanAdjustFlow/index",{
        batch_number:that.batch_number,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      },res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      if(this.batch_number!==''){
        this.getList();
      }
    },
    round(val,num=2) {
      return Math.round(val*100)/100
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./common";
.content2{
  background-color: #ffffff;
  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: row;

    .header-tip-body{
      //width: 500px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      .header-tip-body-item{
        margin-left: 50px;
        display: flex;
        flex-direction: row;
      }
    }
  }
  .pagination-wrap{
    margin-top: 10px;
    text-align: center;
  }

  >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/ExpeditingFeesPlanContenziosoAjustShow.vue